<nav class="navbar navbar-expand-lg bg-transparent position-fixed top-0 start-0 w-100 py-3 z-3">
  <div class="container-fluid px-3 px-md-4 px-lg-5">

    <!-- LEFT: LOGO + BRAND -->
    <router-link
      to="/"
      class="navbar-brand brand-logo d-flex align-items-center gap-2 m-0"
      aria-label="Home"
    >
      <span class="brand-mark"></span>
      <!-- <span class="fw-bold text-white letter-spacing-1">INFINITY</span> -->
    </router-link>

    <!-- MOBILE TOGGLER -->
    <button
      class="navbar-toggler border-0 shadow-none"
      type="button"
      aria-controls="mainNavbar"
      :aria-expanded="is_nav_open ? 'true' : 'false'"
      aria-label="Toggle navigation"
      @click="toggle_nav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- CENTER + RIGHT -->
    <div class="collapse navbar-collapse" id="mainNavbar" :class="{ show: is_nav_open }">

      <!-- CENTER: LINKS -->
      <ul class="navbar-nav mx-lg-auto align-items-lg-center gap-lg-4 mt-3 mt-lg-0">
        <li class="nav-item">
          <a class="nav-link fw-semibold nav-link-hero text-dark" href="#" @click="close_nav">Platform</a>
        </li>
        <li class="nav-item">
          <a class="nav-link fw-semibold nav-link-hero text-dark" href="#" @click="close_nav">Solutions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link fw-semibold nav-link-hero text-dark" href="#" @click="close_nav">Pricing</a>
        </li>
        <li class="nav-item">
          <a class="nav-link fw-semibold nav-link-hero text-dark" href="#" @click="close_nav">Resources</a>
        </li>
      </ul>

      <!-- RIGHT: LOGIN + CTA -->
      <div class="d-flex align-items-center gap-3 ms-lg-auto mt-3 mt-lg-0">

        <!-- ✅ LOGIN (router-link) -->
        <router-link
          to="/login"
          class="fw-semibold nav-link-hero text-decoration-none text-dark"
          @click.native="close_nav"
        >
          Log In
        </router-link>

        <!-- CTA -->
        <router-link
          to="/request-demo"
          class="btn btn-primary px-4 py-2 fw-semibold request-demo-btn"
          @click.native="close_nav"
        >
          Request Demo
        </router-link>

      </div>

    </div>
  </div>
</nav>
